/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Commission_Note_AfterInputs */

const es_ab_commission_note_after = /** @type {(inputs: Ab_Commission_Note_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` del mercado. Solo cuando te conseguimos reservas.`)
};

const gl_ab_commission_note_after = /** @type {(inputs: Ab_Commission_Note_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` do mercado. E só a pagas cando alugas.`)
};

const en_ab_commission_note_after = /** @type {(inputs: Ab_Commission_Note_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. You only pay when you rent out.`)
};

/**
* | output |
* | --- |
* | ". You only pay when you rent out." |
*
* @param {Ab_Commission_Note_AfterInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_commission_note_after = /** @type {((inputs?: Ab_Commission_Note_AfterInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Commission_Note_AfterInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_commission_note_after(inputs)
	if (locale === "en") return en_ab_commission_note_after(inputs)
	return es_ab_commission_note_after(inputs)
});